const state = {
  zuiminart_id:0,//罪名id
  soluId:0,//解决方案id
  hdcolId:0,
  jpclurl:'%E6%B2%A1%E8%B0%83%E4%BC%91%E6%B2%A1%E5%A5%96%E9%87%91%EF%BC%8C%E8%83%BD%E8%BE%9E%E8%81%8C%E8%BE%9E%E8%81%8C%EF%BC%8C%E8%83%BD%E4%B8%8D%E7%94%A8%E4%BB%96%E4%BB%AC%E7%9A%84%E4%B8%9C%E8%A5%BF%E4%B8%8D%E7%94%A8%E4%BB%96%E4%BB%AC%E7%9A%84%E4%B8%9C%E8%A5%BF',
  tiaolisea:{}

}

const mutations = {
  upzmId(state,up_id){
    state.zuiminart_id = up_id
  },
  upsoluId(state,soluId){
    state.soluId = soluId
  },
  uphdcolId(state,hdcolId){
    state.hdcolId = hdcolId
  },
  uptlsea(state,seadata){
    state.tiaolisea = seadata
  },
  
}

const actions = {
 
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

